import React from "react";
import CTABanner from "./CTABanner";
import Features from "./Features";
import Hero from "./Hero";
import Explainer from "./Explainer";
import HowItWorks from "./HowItWorks";
import MoujibCarousel from "./MoujibCarousel";
import Navbar from "./Navbar";
//import SocialProof from "./SocialProof";
//import Testimonials from "./Testimonials";
import Footer from "./Footer";
import "./landing.css";
import Benefits from "./Beneftis";
import CommentValue from "./CommentValue";
import Pricing from "./Pricing";
//import Stats from "./Stats";

const Index = () => {
  return (
    <div className="min-h-screen bg-background landing-theme">
      <Navbar />
      <Hero />
      <Explainer />
      <HowItWorks />
      <MoujibCarousel />
      <Features />
      {/*<SocialProof />*/}
      {/*<Stats />*/}
      {/*<Testimonials />*/}
      <Benefits />
      <CommentValue />
      <Pricing />
      <CTABanner />
      <Footer />
    </div>
  );
};

export default Index;
